<template>
    <div class="home">
        <div class="top-white-box"></div>
        <div class="gift-ideas-loading" v-show="isLoading">
            <button :disabled="true">
                <span class="icon"><img :src="`/Assets/img/spin.svg`" /></span>
            </button>
            <div>Loading</div>
        </div>
        <div class="article-page-title-container" v-if="!isClean">
            <div class="article-page-title" v-if="articleDetails" :style="{backgroundImage: `url('${articleDetails.imgUrl}')`}">
                <div class="article-page-image-replacement">
                </div>
                <div class="article-page-title-details">
                    <h1 class="article-page-title-text">{{articleDetails.title}}</h1>
                    <div class="article-page-date">{{formatDate(articleDetails.date, 'MMM DD, YYYY')}}</div>
                </div>
            </div>
        </div>
        <div v-if="articleDetails" class="article-deals-container">
            <Deals :listOfDeals="articleDetails.deals" :showPrice="true"></Deals>
        </div>
        <div class="top-gray-box" v-if="articleDetails && !isClean">
            <h1>Other Posts You Might Like</h1>
        </div>
        <Articles :excludeArticles="Number($route.params.id)" v-if="articleDetails && !isClean" />        
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import api from '@/api'
import settings from '@/settings'
import { Article } from '@/classes/Articles'
import Articles from "@/components/Articles.vue"
import Deals from "@/components/Deals.vue"
import Cookies from 'js-cookie'

export default defineComponent({
    name: "articledetails",
    components: {
        Articles,
        Deals
    },
    setup() {
        const route = useRoute()
        const isParticipant = ref(false)
        const isLoading = ref(false)
        const articleDetails = ref<Article | null>(null)
        const articleUrl = ref<string | null>(null)
        const isClean = ref(false)
        const logoUrl = ref(settings.logoUrl)

        const formatDate = (date: Date, format: string): string => {
            // You'll need to implement or import a date formatting function
            // This is just a placeholder
            return new Date(date).toLocaleDateString()
        }

        const init = async () => {
            isLoading.value = true
            const articleId = Number(route.params.id)
            articleDetails.value = null
            console.log('articleId', articleId)
            try {
                const response = await api.getArticleDetails(articleId, true)
                const articleDetailsTemp = response.data;
                if(articleDetailsTemp.imgUrl === null) articleDetailsTemp.imgUrl = settings.logoUrl
                articleDetails.value = response.data
                document.title = articleDetails.value.pageTitle + ' | ' + settings.siteNameCaps
            } catch (error) {
                console.error('Error fetching article details:', error)
            } finally {
                isLoading.value = false
            }
        }

        onMounted(() => {
            //use js cookie to get the cookie
            const cookie_lastref = Cookies.get('MMD_ParticipantRefCode')
            if (cookie_lastref) {
                isParticipant.value = true
            }

            isClean.value = !!route.query.direct
            init()
        })

        return {
            isParticipant,
            isLoading,
            articleDetails,
            articleUrl,
            isClean,
            formatDate
        }
    }
})
</script>
